import { ApiClient } from '@/lib/axios/client';
import type { InstantFlowOrgSetting, InstantFlowPublishResult, InstantFlowStatus, InstantFlowSyncResult } from './types';

const basePath = '/api/v1/instant-flow';

export class InstantFlowApi {
  static async status(): Promise<InstantFlowStatus> {
    return await ApiClient.get<InstantFlowStatus>(basePath);
  }

  static async sync(): Promise<InstantFlowSyncResult> {
    return await ApiClient.post<InstantFlowSyncResult>(`${basePath}/sync`);
  }

  static async publish(): Promise<InstantFlowPublishResult> {
    return await ApiClient.post<InstantFlowPublishResult>(`${basePath}/publish`);
  }

  static async deprecate(flowId: string): Promise<void> {
    return await ApiClient.post(`${basePath}/${encodeURIComponent(flowId)}/deprecate`);
  }

  static async orgSetting(orgId: string): Promise<InstantFlowOrgSetting> {
    return await ApiClient.get<InstantFlowOrgSetting>(`/api/v1/orgs/${orgId}/instant-flow`);
  }

  static async setOrgSetting(orgId: string, setting: InstantFlowOrgSetting): Promise<InstantFlowOrgSetting> {
    return await ApiClient.put<InstantFlowOrgSetting>(`/api/v1/orgs/${orgId}/instant-flow`, setting);
  }
}
